import React, {Component} from "react";

import { IS_VALID }       from "utils";

import Create             from "./Create";
import View               from "./View";

class FormContainer extends Component {
    render () {
        let {
            selectedData,
            formType,

            loadOptions
        } = this.props;

        switch (formType.toUpperCase()) {
            case "CREATE":
                return <Create loadOptions={loadOptions}/>
                break;
            case "UPDATE":
                return <Create loadOptions={loadOptions}/>
                break;
            case "VIEW":
                return <View />
                break;
            case "DELETE":
                return (
                    <p>
                        Are you sure you want to delete&nbsp;
                        {IS_VALID(selectedData) && IS_VALID(selectedData.get("title")) ? (
                            <span style={{ color: "red" }}>{selectedData.get("title")}</span>
                        ) : (
                            "this data"
                        )}
                        ?
                    </p>
                );
                break;
            default:
                return "";
                break;
        }
    }

    componentWillUnmount () {
        let {
            actions,

            evoucherSortColumnOptions,
            evoucherSortingOptions
        } = this.props;

        actions.setValue({
            selectedData: null,
            formType: "",
            formId: "",

            image: null,
            bannerImage: null,
            title: "",
            descriptions: "",
            earningPeriod: null,
            earningPeriodStartDate: "",
            earningPeriodEndDate: "",
            campaignStartDate: "",
            campaignEndDate: "",
            evoucherSortColumn: evoucherSortColumnOptions[0],
            evoucherSorting: evoucherSortingOptions[0],

            availabilityStartTime: "",
            availabilityEndTime: ""
        });
    }
}

import {connect}            from 'react-redux';
import {bindActionCreators} from 'redux';
import {generics}           from 'actions';
import {
  CAMPAIGN_CATEGORY
}                           from "actions/const";

function mapStateToProps(state) {
	let {
        CampaignCategory
    } = state;
    
    let {
        selectedData,
        formType,
        evoucherSortColumnOptions,
        evoucherSortingOptions
    } = CampaignCategory;

	return {
        selectedData,
        formType,
        evoucherSortColumnOptions,
        evoucherSortingOptions
	};
}

function mapDispatchToProps(dispatch) {
    const actions = {
        setValue: (state, action = CAMPAIGN_CATEGORY) => generics.setValue(action, state)
    };
  
    return {
        actions: bindActionCreators(actions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(FormContainer);


// WEBPACK FOOTER //
// ./components/CampaignCategory/FormContainer/index.js